import {
  Flex,
  FlexBetween,
  FlexJustifyCenter,
  HubLengthMessage
} from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { USDT, formatUSD } from '../../../helpers/helperFunctions';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { InvoiceHeader, InvoicesMobile, Invoices } from '../AccountingStyled';
import { Dispatch, SetStateAction } from 'react';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';
import { CaptionText } from '../../../styles/FontStyles';

interface WithdrawalsPageType {
  withdrawals: any;
  countWithdrawals: number;
  setCountWithdrawals: Dispatch<SetStateAction<number>>;
}

export const WithdrawalsPage = ({
  withdrawals,
  countWithdrawals,
  setCountWithdrawals
}: WithdrawalsPageType) => {
  const { t } = useTranslation('accounting');

  const withdrawalStatus = (status: number) => {
    switch (status) {
      case 1:
        return t('pending');
      case 2:
        return t('paid');
      case 3:
        return t('completed');
      case 4:
        return t('canceled');
      case 5:
        return t('automatic_payout_in_progress');
      case 6:
        return t('paid');
      default:
    }
  };

  const showToolTipCards = (item: any) => {
    return (
      <div>
        <CaptionText>
          Name: {item.firstName} {item.lastName}
        </CaptionText>
        <CaptionText>IBAN: {item.iban}</CaptionText>
        <CaptionText>Country: {item.countryCode}</CaptionText>
        <CaptionText>City: {item.city}</CaptionText>
        <CaptionText>Street: {item.street}</CaptionText>
      </div>
    );
  };

  return (
    <AnimatedTab key={'WithdrawalsPage'}>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '14.29%' }}>Date Created</div>
          <div style={{ width: '14.29%' }}>Date Paid</div>
          <div style={{ width: '14.26%' }}>{t('id_withdrawal')}</div>
          <div style={{ width: '14.29%' }}>{t('amount')}</div>
          <div style={{ width: '14.29%' }}>{t('fee')}</div>
          <div style={{ width: '14.29%' }}>{t('paid_amount')}</div>
          <div style={{ width: '14.29%' }}>{t('status')}</div>
        </InvoiceHeader>
      </Desktop>

      {withdrawals?.length === 0 ? (
        <HubLengthMessage>{t('no_withdrawals')}</HubLengthMessage>
      ) : (
        withdrawals?.map((inv: any, i: number) => {
          return (
            <AnimatedItem index={i} key={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '14.29%' }}>
                    {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '14.29%' }}>
                    {inv?.datePaid &&
                      moment.utc(inv?.datePaid).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '14.26%' }}>
                    #{inv.id}{' '}
                    <TextWithTooltip
                      margin='30px 0 0 0'
                      tooltip={showToolTipCards(inv)}
                      width='auto'
                      column='column'
                    />
                  </div>
                  <div style={{ width: '14.29%' }}>
                    {' '}
                    <span>{formatUSD(inv.amount)} EUR</span>
                  </div>
                  <div style={{ width: '14.29%' }}>
                    <span>{formatUSD(inv.feeAmount)} EUR</span>
                  </div>
                  <div style={{ width: '14.29%' }}>
                    <span>{formatUSD(inv.paidAmount)} EUR</span>
                  </div>

                  <div style={{ width: '14.29%' }}>
                    {withdrawalStatus(inv.status)}
                  </div>
                </Invoices>
              </Desktop>
              <Mobile>
                <Mobile>
                  <InvoicesMobile>
                    <FlexBetween>
                      <Flexed column>
                        <div
                          style={{
                            fontWeight: 500,
                            lineHeight: '20px'
                          }}>
                          #{inv.id}{' '}
                          <TextWithTooltip
                            margin='30px 0 0 0'
                            tooltip={showToolTipCards(inv)}
                            width='auto'
                            column='column'
                          />
                        </div>
                        <div>
                          {inv?.datePaid &&
                            moment.utc(inv?.datePaid).format('DD/MM/YY')}
                        </div>
                        <div
                          style={{
                            color: '#B5A8A8',
                            lineHeight: '18px',
                            fontSize: 12
                          }}>
                          {withdrawalStatus(inv.status)}
                        </div>
                      </Flexed>
                      <Flexed column alignEnd>
                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 18
                          }}>
                          {formatUSD(inv.amount)} {USDT}
                        </div>

                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 18
                          }}>
                          {formatUSD(inv.feeAmount)} {USDT}
                        </div>

                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 18
                          }}>
                          {formatUSD(inv.paidAmount)} {USDT}
                        </div>
                      </Flexed>
                    </FlexBetween>
                  </InvoicesMobile>
                </Mobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
      {withdrawals?.length >= 50 &&
        withdrawals?.length === countWithdrawals && (
          <FlexJustifyCenter>
            <Button
              w='200px'
              mt='10'
              mb='20'
              onClick={() => setCountWithdrawals((count) => count + 50)}>
              {t('show_more')}
            </Button>
          </FlexJustifyCenter>
        )}
    </AnimatedTab>
  );
};
